module.exports = __webpack_public_path__ + "static/04-385ba630ddbf0c5bcb34d0c15772ee63.jpg";